import { gql } from '@apollo/client'

const DISH_NAMES_QUERY = gql`
  query dishNamesQuery($filters: DishFiltersInput!) {
    dishNames(filters: $filters) {
      id
      name
    }
  }
`

export default DISH_NAMES_QUERY
